import type { DomainStatus } from '@gl/shared';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const STATUS: Record<DomainStatus, { label: string; className?: string; variant: 'success' | 'secondary' | 'destructive' | 'outline' }> = {
  PENDING_DNS: { label: 'Pendiente DNS', variant: 'outline', className: 'border-amber-300 text-amber-700 dark:text-amber-300' },
  PENDING_SSL: { label: 'Pendiente SSL', variant: 'outline', className: 'border-sky-300 text-sky-700 dark:text-sky-300' },
  ACTIVE: { label: 'Activo', variant: 'success' },
  ERROR: { label: 'Error', variant: 'destructive' },
  REMOVED: { label: 'Quitado', variant: 'secondary' },
};

export function DomainStatusBadge({ status }: { status: DomainStatus }) {
  const s = STATUS[status];
  return (
    <Badge variant={s.variant} className={cn(s.className)}>
      {s.label}
    </Badge>
  );
}
